import _classCallCheck from "/home/node/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/home/node/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/createClass.js";
import _assertThisInitialized from "/home/node/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/assertThisInitialized.js";
import _possibleConstructorReturn from "/home/node/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/possibleConstructorReturn.js";
import _getPrototypeOf from "/home/node/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/getPrototypeOf.js";
import _inherits from "/home/node/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/inherits.js";
var __jsx = React.createElement;
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
import React, { Component } from 'react';
import onClickOutside from 'react-onclickoutside';
var IconDefault = "/static/offers/info-icon.svg";
var IconWhite = "/static/offers/info-icon-white.svg";
import Link from 'next/link';
import { BoxContainer, TooltipContainer, TooltipContent, TooltipTitle, RightArrow } from "./style";
var InfoBox = /*#__PURE__*/function (_Component) {
  function InfoBox() {
    var _this;
    _classCallCheck(this, InfoBox);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    return _possibleConstructorReturn(_this, (_this = _callSuper(this, InfoBox, [].concat(args)), _this.state = {
      showTooltip: false
    }, _this.toggleTooltip = function () {
      _this.setState({
        showTooltip: !_this.state.showTooltip
      });
    }, _this.closeTooltip = function () {
      _this.setState({
        showTooltip: false
      });
    }, _assertThisInitialized(_this)));
  }
  _inherits(InfoBox, _Component);
  return _createClass(InfoBox, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
        title = _this$props.title,
        bulletPoints = _this$props.bulletPoints,
        linkUrl = _this$props.linkUrl,
        tooltip = _this$props.tooltip,
        tooltipTitle = _this$props.tooltipTitle,
        className = _this$props.className,
        tipIcon = _this$props.tipIcon,
        centered = _this$props.centered;
      var showTooltip = this.state.showTooltip;
      var BoxContent = function BoxContent() {
        return __jsx("div", null, __jsx("h3", null, title), __jsx("ul", null, bulletPoints.map(function (point, i) {
          return __jsx("li", {
            key: i
          }, point);
        })), linkUrl && __jsx(Link, {
          href: linkUrl
        }, __jsx("a", null, "Learn more ", __jsx(RightArrow, null))));
      };
      var HowItWorks = tooltip ? onClickOutside(BoxContent) : BoxContent;
      return __jsx("div", {
        className: className
      }, tooltip ? __jsx(TooltipContainer, null, __jsx(TooltipTitle, {
        className: "ignore-react-onclickoutside",
        onClick: this.toggleTooltip
      }, __jsx("img", {
        src: tipIcon ? IconWhite : IconDefault,
        alt: tooltipTitle
      }), __jsx("span", null, tooltipTitle)), showTooltip && __jsx(TooltipContent, {
        position: centered
      }, __jsx(BoxContainer, null, __jsx(HowItWorks, {
        handleClickOutside: this.closeTooltip,
        disableOnClickOutside: !showTooltip,
        linkUrl: "/how-it-works"
      })))) : __jsx(BoxContainer, null, __jsx(HowItWorks, null)));
    }
  }]);
}(Component);
InfoBox.defaultProps = {
  className: '',
  tooltip: false,
  tooltipTitle: '',
  tipIcon: false,
  centered: false,
  linkUrl: ''
};
export default InfoBox;